export enum AccountKind {
  User = 'User',
  Virtual = 'Virtual',
}
